import React from 'react'

interface Props {
  children: string
  data: Record<string, string>
}

export const T = ({ children, data }: Props) => <>{t(children, data)}</>

export const t = (translation: string, placeholders: Record<string, string>) =>
  translation.replace(/{([^{}]*)}/g, (_, key: string) => placeholders[key])
